<template>
  <v-main class="pa-0" style="max-width: unset">
    <HeaderConfig :title="title" @voltar="$router.go(-1)" :haveAction="false"/>

    <v-dialog v-model="dialog" max-width="500">
      <Confirm
          title="Imagem do perfil"
          message="Tem certeza de que deseja exluir a foto do perfil?"
          buttonText="Sim"
          @cancel="dialog = false"
          @action="excluirFoto()"
      />
    </v-dialog>

    <v-dialog v-model="dialogAterarAdicionarFotoPerfil" max-width="500">
      <Confirm
          title="Imagem do perfil"
          :message="`Tem certeza de que deseja ${currentUser.image ? 'alterar' : 'adicionar'} a foto do perfil?`"
          buttonText="Sim"
          @cancel="dialogAterarAdicionarFotoPerfil = false"
          @action="openPicker()"
      />
    </v-dialog>

    <v-file-input
        id="imageInput"
        accept="image/png, image/jpeg,image/jpg"
        style="display: none"
        :disabled="step == 3"
        @change="setImage"
    ></v-file-input>

    <v-container style="max-width: unset; background: #e5e5e5">
      <v-row class="ma-0" align="start">
        <v-col cols="12" lg="3" md="3" sm="12">
          <div class="d-flex flex-column align-center justify-center">
            <v-hover v-slot="{ hover }" v-if="currentUser.image != null">
              <v-img
                  :src="currentUser.image"
                  style="
                  border-radius: 8px !important;
                  opacity: 0.7;
                  cursor: pointer;
                "
                  max-height="166"
                  max-width="221"
                  :class="hover? 'elevation-5 mx-2' : 'mx-2'"
              >
                <v-expand-transition>
                  <div
                      v-if="hover"
                      class="d-flex flex-column justify-center align-center"
                      style="height: 100%; background: rgba(188, 0, 0, 0.6);"
                      @click="dialogAterarAdicionarFotoPerfil = true"
                  >
                    <v-icon size="26" color="white">mdi-pen</v-icon>
                    <span class="edit-photo">Alterar foto</span>
                  </div>
                </v-expand-transition>
              </v-img>
            </v-hover>
            <span
                class="delete-photo"
                v-if="currentUser.image != null"
                @click="dialog = true"
            >
              Excluir
            </span>

            <div
                class="d-flex flex-column align-center"
                style="max-width: 150px"
                v-if="currentUser.image == null"
            >
              <v-hover v-slot="{ hover }">
                <div
                    class="image-container mx-2"
                    @click="dialogAterarAdicionarFotoPerfil = true"
                    :style="hover ? 'background: #C4C4C4' : ''"
                >
                  <v-img
                      src="../../../assets/imp.svg"
                      contain
                      max-width="157"
                      v-if="!hover"
                  >
                  </v-img>
                  <div
                      v-if="hover"
                      class="d-flex flex-column align-center"
                  >
                    <v-img
                        src="../../../assets/add_photo.svg"
                        contain
                        max-width="46"
                    >
                    </v-img>
                    <span class="photo-field" v-if="hover">Adicionar Foto</span>
                  </div>
                </div>
              </v-hover>
            </div>
          </div>

          <div>
            <v-card class="steps-card py-4" elevation="0">
              <v-list>
                <v-list-item-group>
                  <v-list-item
                      v-for="(item, i) in menu"
                      class="active-item"
                      :style="item.component === component  ? 'background: #2d3038!important; color: white !important;' : 'background: #FFFFFF!important; color: #2d3038 !important;'"
                      @click="stepChange(item.component)"
                      :key="i"
                  >

                    <template v-slot:default="{ }">
                      <v-icon
                          :color="item.component === component ? '#FFFFFF' : '#BC0000'"
                          v-text="item.icon"
                      ></v-icon>
                      {{ item.text }}
                    </template>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-card>
          </div>
        </v-col>

        <v-col>
          <v-card class="infos-card pa-6 mt-0" elevation="0">
            <v-row cols="12" sm="12" md="12" lg="12">
              <component :is="component"></component>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<style scoped>
.empty-message {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 2rem;
  line-height: 3.2rem;

  color: #97999d;
}

.empty-label {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 1.1rem;

  color: #97999d;
}

.terms-text {
  font-style: normal;
  font-weight: 300;
  font-size: 11px;
  line-height: 150%;
  color: #202020;
}

.terms {
  padding: 15px;
  background: #ffffff;
  border: 1px solid #c4c4c4;
  box-sizing: border-box;
  border-radius: 5px;

  overflow-y: scroll;

  max-height: 205px;
}

.terms::-webkit-scrollbar {
  background: #fff;
  border-radius: 3.5px;
  width: 4px;
}

.terms::-webkit-scrollbar-thumb {
  background: #c4c4c4;
  border-radius: 3.5px;
  width: 4px;
}

.terms-field {
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.15px;
  color: #202020;
}

.type-manually {
  cursor: pointer;
  font-weight: bold;
  color: #bc0000;
  border-bottom: 1px solid #bc0000;
}

.required-field {
  font-weight: 300;
  font-size: 12px;
  line-height: 124.4%;
  color: #ff2626;
}

.label {
  font-weight: bold;
  font-size: 12px;
  line-height: 124.4%;
  color: #9c9c9c;
}

.step-title {
  font-weight: bold;
  font-size: 16px;
  line-height: 124.4%;
  color: #000000;
}

.step-subtitle {
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 124.4%;
  color: #9c9c9c;
}


.infos-card {
  box-shadow: 0px 7px 20px rgba(45, 48, 56, 0.1) !important;
  border-radius: 6px;
}

.steps-card {
  box-shadow: 0px 7px 20px rgba(45, 48, 56, 0.1) !important;
  border-radius: 6px;
}

.item {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
  color: #2d3038;
}

.active-item {
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 27px;
}

.delete-photo {
  cursor: pointer;
  font-weight: normal;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #bc0000;
}

.edit-photo {
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: 0.15px;
  color: #ffffff;
}

.photo-field {
  font-weight: 600;
  font-size: 18px;
  line-height: 27px;
  /* identical to box height */

  letter-spacing: 0.15px;

  color: #9c9c9c;
}

.image-container {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 221px;
  height: 166px;

  background: #dadada;
  border-radius: 20px;

  cursor: pointer;
  transition: 0.1s;
  box-sizing: border-box;
  border-radius: 10px !important;
}

.text-span {
  font-size: 20px;
  font-style: normal;
  font-weight: bold;
}
</style>

<script>
import ApiService from "../../../services/ApiService";
import Utils from "../../../Utils/FormatDate";
import HeaderConfig from "./components/HeaderConfig.vue";
import PersonalInformation from "./components/PersonalInformation.vue";
import Address from "./components/Address.vue";
import ChangePassword from "./components/ChangePassword.vue";
import StandardShippingResellers from "./components/StandardShippingResellers.vue";
import MarketplacePercentage from "./components/MarketplacePercentage.vue";
import DiscountApplicators from "./components/DiscountApplicators.vue";
import WithdrawalOrderGuidelines from "./components/WithdrawalOrderGuidelines.vue";
import TokenMelhorEnvio from "./components/TokenMelhorEnvio.vue";
import BankInformation from "./components/BankInformation.vue";
import PlatformPolicies from "./components/PlatformPolicies.vue";
import ShippingPackaging from "./components/ShippingPackaging.vue";
import ShowcaseSettings from "./components/ShowcaseSettings.vue";
import bancosBrasil from "../../../assets/bancosBrasil.json";
import Confirm from "../components/ConfirmExit.vue";
import {VMoney} from "v-money";
import Vue from "vue";
import axios from "axios";

export default {
  name: "Register",

  props: {
    product: Object,
  },

  components: {
    HeaderConfig,
    Confirm,
    PersonalInformation,
    Address,
    ChangePassword,
    StandardShippingResellers,
    MarketplacePercentage,
    DiscountApplicators,
    WithdrawalOrderGuidelines,
    TokenMelhorEnvio,
    BankInformation,
    PlatformPolicies,
    ShippingPackaging,
    ShowcaseSettings,
  },

  async created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    await this.updateUser();
    this.preencherMenu();
  },
  directives: {money: VMoney},
  data: () => ({
    menu: [
      {text: "Informações pessoais", icon: "mdi-account-outline", component: "PersonalInformation"},
      {text: "Endereço", icon: "mdi-google-maps", component: "Address"},
      {text: "Alterar senha", icon: "mdi-shield-lock-outline", component: "ChangePassword"},
      {text: "Frete padrão", icon: "mdi-truck-fast-outline", component: "StandardShippingResellers"},
      {text: "Porcentagem vendas", icon: "mdi-percent-outline", component: "MarketplacePercentage"},
      {text: "Desconto aplicador", icon: "mdi-ticket-percent-outline", component: "DiscountApplicators"},
      {text: "Políticas da plataforma", icon: "mdi-cog-outline", component: "PlatformPolicies"},
    ],
    component: "PersonalInformation",
    currentUser: {
      image: "",
      Name: "",
      defaultFrete: "",
      agreement: false,
      cnpj: "",
      inscrEstadual: "",
      phoneNumber: "",
      phoneNumber2: "",
      birthDate: "",
      postalCode: "",
      state: "",
      city: "",
      neighborhood: "",
      addressName: "",
      addressNumber: "",
      country: "",
      addressComplement: "",
      resaleRegion: "",
      category: "",
      region: "",
      password: "",
      password2: "",
      email: "",
      email2: "",
      resaleWebSite: "",
      receiveEmail: "",
      receiveSms: "",
      textObservation: "",
      tokenMelhorEnvio: ""
    },
    apiService: new ApiService(),
    step: null,
    title: "",
    dialog: false,
    dialogAterarAdicionarFotoPerfil: false,
    stepDefault: "PersonalInformation",
    user: {},
    userTypeMaster: 0,
    userTypeAdmin: 1,
    userTypeResale: 2,
    userTypeInstaller: 3,
    userTypeFinancial: 5,
    specialties: [],
  }),

  watch: {
  },

  methods: {
    preencherMenu() {
      console.log(this.user.type)
      if (this.user.type === this.userTypeResale) {
        this.menu = [
          {text: "Informações pessoais", icon: "mdi-account-outline", component: "PersonalInformation"},
          {text: "Endereço", icon: "mdi-google-maps", component: "Address"},
          {text: "Alterar senha", icon: "mdi-shield-lock-outline", component: "ChangePassword"},
          {text: "Detalhes retirar produto", icon: "mdi-details", component: "WithdrawalOrderGuidelines"},
          {text: "Frete", icon: "mdi-truck-delivery", component: "TokenMelhorEnvio"},
          {text: "Informações bancárias", icon: "mdi-bank-check", component: "BankInformation"},
          /*{text: "Embalagem para envio", icon: "mdi-package-variant", component: "ShippingPackaging"},*/
          {text: "Configuração da vitrine", icon: "mdi-cog-outline", component: "ShowcaseSettings"},
        ]
      } else if (this.user.type === this.userTypeInstaller || this.user.type === this.userTypeFinancial) {
        this.menu = [
          {text: "Informações pessoais", icon: "mdi-account-outline", component: "PersonalInformation"},
          {text: "Endereço", icon: "mdi-google-maps", component: "Address"},
          {text: "Alterar senha", icon: "mdi-shield-lock-outline", component: "ChangePassword"},
        ]
      }
    },

    async excluirFoto() {
      this.dialog = false;
      this.currentUser.image = null
      await this.submit()
    },


    async setImage(image) {
      if (image.size < 2097152) {
        const reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = () => {
          this.currentUser.image = reader.result;
        };
        setTimeout(async () => {
          this.dialogAterarAdicionarFotoPerfil = false;
          await this.submit()
        }, 1000)
      } else {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Arquivo excede o limite de 2mb",
          trace: null,
        });
      }
    },

    openPicker() {
      document.querySelector("#imageInput").click();
    },

    stepChange(component) {
      this.component = component;
    },

    async updateUser() {
      this.loading = true;

      let url= '';
      switch (this.user.type) {
        case 0:
          url = "user/get-one";
          break;
        case 1:
        case 5:
          url = "user/get-one";
          break;
        case 2:
          url = "resale/get-one";
          break;
        case 3:
          url = "installer/get-one";
          break;
      }
      await this.apiService.get(`${url}?id=${this.user.id}`).then((response) => {
        console.log('response')
        console.log(response)
        console.log('response')
        this.currentUser = response;
        this.specialties = this.currentUser.specialties;
        this.loading = false;
      });
    },

    async submit() {
      this.loading = true;
      let url = "resale/edit-user-resale";

      switch (this.currentUser.type) {
        case 0:
          url = "user/edit";
          break;
        case 1:
          url = "user/edit";
          break;
        case 2:
          url = "resale/edit-user-resale";
          break;
        case 3:
          url = "installer/edit";
          this.currentUser.specialties = [];
          this.specialties.forEach((x) => {
            this.currentUser.specialties.push({
              specialtiesId: x.specialtiesId,
              installerId: this.currentUser.id,
            });
          });
          break;
      }
      await this.apiService.post(url, this.currentUser)
          .then((resp) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "success",
              title: resp.message,
              message: this.currentUser.image ? 'Imagem do perfil alterada com sucesso': 'Imgem do perfil excluida com sucesso',
              trace: null,
            });

            this.dialog = false;
            this.loading = false;
          })
          .catch((err) => {
            Vue.$globalEvent.$emit("onFlashMessage", {
              type: "error",
              title: "Erro ao cadastrar produto",
              message: err.body.message,
              trace: null,
            });

            this.dialog = false;
            this.loading = false;
          });
      await this.updateUser();
    },
  },
};
</script>
